export enum CustomEventTypeEnum {
  CUSTOM = 'custom',
  AI = 'ai',
  MARKETING = 'marketing',
}
